import React from "react";
import DateFilter from "components/DateFilter/DateFilter";
import { CheckBox, SelectBar } from "components/ui-component";
import ArrowSelectIconDark from "components/Icons/ArrowSelectIconDark";

interface SentFaxFiltersProps {
  setFilter: (filter: any) => void;
  sentType: any;
  activeTab: any;
  status_filter: string;
  statusOptions: { value: string; label: string }[];
  dispatch: any;
  setStatusFilter: any;
  filter: any;
  hide_deleted: string;
  handleChange: (e: any) => void;
  className?: string;
  showIncompleteSentFaxes: boolean;
  setShowIncompleteSentFaxes: (value: boolean) => void;
}

const SentFaxFilters: React.FC<SentFaxFiltersProps> = ({
  setFilter,
  sentType,
  activeTab,
  status_filter,
  statusOptions,
  dispatch,
  setStatusFilter,
  filter,
  hide_deleted,
  handleChange,
  className = "",
  showIncompleteSentFaxes,
  setShowIncompleteSentFaxes,
}) => (
  <>
    <DateFilter
      setSelectDate={setFilter}
      dateFilter={sentType}
      faxActiveTab={activeTab}
      className={className}
    />
    <SelectBar
      style={{ width: 150 }}
      defaultValue={status_filter}
      options={statusOptions}
      value={status_filter}
      onChange={(value) => {
        setFilter({
          ...filter,
          status_filter: value,
          page: "1",
          per_page: "10",
        });
        dispatch(setStatusFilter(value));
      }}
      suffixIcon={<ArrowSelectIconDark />}
    />
    <CheckBox checked={hide_deleted === "no"} onChange={handleChange}>
      Show Deleted Faxes
    </CheckBox>
    <CheckBox
      checked={showIncompleteSentFaxes}
      onChange={() => {
        dispatch(setShowIncompleteSentFaxes(!showIncompleteSentFaxes));
      }}
    >
      Show Incomplete Faxes
    </CheckBox>
  </>
);

export default SentFaxFilters;
